import { create } from "zustand";
import { persist } from 'zustand/middleware';

import storage from './encryptedStorage';

type CurrencyT = {
  UFValue: number;
  UFDate: number;
};

const currencyBase = {
  UFValue: 0,
  UFDate: Date.now(),
};

interface CurrencyStoreStateI {
  currency: CurrencyT;
  isInitialized: boolean;
  setCurrency: (currency: CurrencyT) => void;
}

const useCurrencyStore = create<CurrencyStoreStateI>()(
  persist(
    (set) => ({
      currency: currencyBase,
      isInitialized: false,
      setCurrency: (currency) => set({ currency }),
    }),
    {
      name: 'deceso-currency-storage',
      storage
    }
  )
);

export default useCurrencyStore;
